import React from 'react';

const TextBlast = ({ color='currentColor' }: { color?: string }) => {
  return <svg width="6.0854101mm" height="6.423605mm" viewBox="0 0 18 16" fill="none" version="1.1" id="svg1342"
              xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M 13.879107,14.709 C 12.385158,15.559139 10.695003,16.004171 8.9761067,16 4.0031067,16 -0.02389328,12.413 1.0672118e-4,7.988 1.0672118e-4,3.563 4.0261067,0 9.0001067,0 c 4.9740003,0 9.0000003,3.587 9.0000003,7.988 0,1.913 -0.758,3.66 -2.013,5.023 0.237,0.645 0.64,1.363 1.42,1.865 0.19,0.12 0.143,0.43 -0.094,0.454 -0.781,0.12 -2.155,0.144 -3.434,-0.621 z m -0.521,-7.678 h -1.942 v 1.962 h 1.942 V 7.03 Z m -3.4100003,0 h -1.943 v 1.962 h 1.942 V 7.03 Z m -3.411,0 h -1.942 v 1.962 h 1.942 V 7.03 Z"
          fill={color}/>
  </svg>;
};

export default TextBlast;
